
import Config from "@/config/config.js"
import AsyncUtils from "@/utils/asyncUtils.js"
import Services, { handleError } from "./index.service";
import { getSession } from "@/hooks/useSession.js";
const { OshimedBackend, OshimedAPI } = Services;


/**
 * POST /sites/add-to-study – Ajoute un site et son ICF à une étude existante.
 * Utilise OshimedBackend et retourne directement la réponse sans wrapper `success`.
 *
 * @param {object} sitePayload – Données nécessaires à la création du site.
 * @returns {Promise<object|null>} – Données du site ou erreur normalisée.
 */
const addSiteToStudy = async (sitePayload) => {
    console.log("=== Service: addSiteToStudy called === study.service.js === key: 228410 ===")
    console.log("→ sitePayload:", sitePayload)
    console.log("=================================")
  
    try {
      const response = await OshimedBackend.post(`/site/add-to-study`, sitePayload)
  
      if (!response?.data) {
        console.warn("Empty response from addSiteToStudy")
        return null
      }

      console.log('=== response.data === site.service.js === key: 331843 ===');
      console.dir(response.data, { depth: null, colors: true })
      console.log('=================================');
  
      return response.data
    } catch (error) {
      console.error("Service error in addSiteToStudy:", error)
      return handleError(error, 228412)
    }
  }

  /**
 * DELETE /site/:siteId – Supprime logiquement un site via son ID (activated = false)
 *
 * @param {string} siteId – L'UUID du site à désactiver
 * @returns {Promise<object|null>} – Résultat de la suppression ou erreur normalisée
 */
const deactivateSiteById = async (siteId) => {
  console.log("=== Service: deactivateSiteById called === site.service.js === key: 987121 ===")
  console.log("→ siteId:", siteId)
  console.log("=================================")

  try {
    const response = await OshimedBackend.patch(`/site/${siteId}`)

    if (!response?.data) {
      console.warn("Empty response from deactivateSiteById")
      return null
    }

    console.log("=== API response === site.service.js === key: 987122 ===")
    console.dir(response.data, { depth: null, colors: true })
    console.log("=================================")

    return response.data
  } catch (error) {
    console.error("Service error in deactivateSiteById:", error)
    return handleError(error, 987123)
  }
}

const SiteService = {
  addSiteToStudy, deactivateSiteById,
}

export default SiteService
export { addSiteToStudy, deactivateSiteById, }